// src/components/pages/DataSources.jsx
import {
  Box,
  Container,
  Heading,
  Text,
  Stack,
  List,
  ListItem,
} from "@chakra-ui/react";

export default function DataSources() {
  return (
    <Box py={{ base: 10, md: 16 }}>
      <Container maxW="4xl">
        <Heading size="2xl" mb={4}>
          Data & Sources
        </Heading>
        <Stack spacing={4} fontSize="md">
          <Text>
            We use a combination of public records, company disclosures, and
            customer feedback.
          </Text>
          <List.Root as="ul" pl={6} spacing={2}>
            <List.Item>Regulatory filings & professional directories</List.Item>
            <List.Item>
              Company websites, fee schedules, and contracts
            </List.Item>
            <List.Item>Aggregated reviews and outcome reports</List.Item>
          </List.Root>
          <Text fontSize="sm" opacity={0.8}>
            Last updated: {new Date().toLocaleDateString()}
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
